import React, { useMemo, useRef, useEffect, useState, Suspense } from 'react';
import 'react-quill-new/dist/quill.snow.css';

const QuillEditor = ({ value, onChange, modules, formats, placeholder }) => {
  const [ReactQuill, setReactQuill] = useState(null);
  const quillRef = useRef(null);
  
  useEffect(() => {
    import('react-quill-new').then((module) => {
      setReactQuill(() => module.default);
    });
  }, []);

  if (!ReactQuill) {
    return (
      <div className="border rounded p-4 min-h-[200px] flex items-center justify-center text-gray-500 bg-gray-50 dark:bg-gray-800">
        Loading editor...
      </div>
    );
  }

  return (
    <ReactQuill
      ref={quillRef}
      theme="snow"
      value={value || ''}
      onChange={onChange}
      modules={modules}
      formats={formats}
      placeholder={placeholder}
    />
  );
};

export const RichTextEditor = ({ value, onChange, placeholder }) => {
  const modules = useMemo(() => ({
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'color': [] }, { 'background': [] }],
      ['link'],
      ['clean']
    ],
  }), []);

  const formats = useMemo(() => [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list',
    'color', 'background',
    'link'
  ], []);

  return (
    <div className="rich-text-editor">
      <QuillEditor
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
      />
      <style jsx>{`
        .rich-text-editor .ql-container {
          min-height: 200px;
          font-size: 16px;
        }
        .rich-text-editor .ql-editor {
          min-height: 200px;
        }
      `}</style>
    </div>
  );
};
